import { SbBlokData } from '@storyblok/react/rsc'

export default function FallbackComponent({ blok }: { blok: SbBlokData }) {
  // Log the error for developers but don't show anything to users
  if (process.env.NODE_ENV === 'development') {
    console.error(`Missing Storyblok component: "${blok.component}"`, blok)
    return (
      <div
        style={{
          border: '2px dashed #ff6b6b',
          padding: '1rem',
          margin: '1rem 0',
          backgroundColor: '#ffe0e0',
          color: '#d63031',
        }}
      >
        <p>
          <strong>DEV ONLY:</strong> Component &quot;{blok.component}&quot; not found
        </p>
        <pre>{JSON.stringify(blok, null, 2)}</pre>
      </div>
    )
  }

  // In production, render nothing - component just disappears silently
  return null
}
